package br.com.texeratx.boardgametimeapp.ui.screens.games

data class GamesFilter(
    val category: String? = null,
    val mode: String? = null,
    val players: Int? = null
)

